import { sprintf } from 'sprintf-js'
import { GreenTriangle } from '../components/atoms/GreenTriangle'
import { Box, Stack } from '@mui/material'
import { RedTriangle } from '../components/atoms/RedTriangle'
import { Trans } from 'react-i18next'

/**
 * A collection of numeric utilies.
 */

/**
 * Neater number presentation.
 */
export function numeric(n: number | null, decimals: number, tax: number | null = null): string {
  if (n === null) {
    return `--,${'-'.repeat(decimals)}`
  }
  return sprintf(`%.${decimals}f`, tax === null ? n : n * (1 + tax)).replace('.', ',')
}

/**
 * Neater number presentation for differenece.
 */
export function numdiff(n1: number | null, n2: number | null, decimals: number, tax: number | null, unit: JSX.Element): JSX.Element {
  let s: string
  if (n1 === null || n2 === null) {
    n1 = 0
    n2 = 0
    s = '±' + numeric(null, decimals)
  } else {
    // Avoid confusing +0,00 or -0,00
    n1 = Math.round(n1 * Math.pow(10, decimals)) / Math.pow(10, decimals)
    n2 = Math.round(n2 * Math.pow(10, decimals)) / Math.pow(10, decimals)
    s = (n2 > n1 ? '+' : n2 === n1 ? '±' : '') + numeric(n2 - n1, decimals, tax)
  }

  let color
  if (n2 === n1) {
    color = undefined
  } else if (n2 > n1) {
    color = 'error.light'
  } else {
    color = 'success.light'
  }
  return <Box component="span" sx={{ color }}>{s} {unit}</Box>
}

/**
 * If either number is bigger than the other, give positive or negative judgement.
 */
export function trend(n1: number | null, n2: number | null): JSX.Element {
  if (n1 === null || n2 === null) {
    return <></>
  }
  if ((n2 || 0) > (n1 || 0)) {
    return <Stack direction="row">
      <RedTriangle/>&nbsp;<Trans>Above reference average</Trans>
    </Stack>
  }
  return <Stack direction="row">
    <GreenTriangle/>&nbsp;<Trans>Below reference average</Trans>
  </Stack>
}
